// Messages for operator/settings/ReferenceData (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.reference_data.head': 'Reference data — Operator',
  'operator.reference_data.all_settings': 'All settings',
  'operator.reference_data.title': 'Reference data — Locations',
  'operator.reference_data.desc': 'Ports, airports & cities (UN/LOCODE)',
  'operator.reference_data.search_aria': 'Search locations',
  'operator.reference_data.search_placeholder': 'Search name, city or UN/LOCODE…',
  'operator.reference_data.col.unlocode': 'UN/LOCODE',
  'operator.reference_data.col.name': 'Name',
  'operator.reference_data.col.country': 'Country',
  'operator.reference_data.col.type': 'Type',
  'operator.reference_data.empty': 'No locations match.',
  'operator.reference_data.load_more': 'Load more',
}

export const zhTW = {
  'operator.reference_data.head': '參考資料 — 操作員',
  'operator.reference_data.all_settings': '所有設定',
  'operator.reference_data.title': '參考資料 — 地點',
  'operator.reference_data.desc': '港口、機場與城市（UN/LOCODE）',
  'operator.reference_data.search_aria': '搜尋地點',
  'operator.reference_data.search_placeholder': '搜尋名稱、城市或 UN/LOCODE…',
  'operator.reference_data.col.unlocode': 'UN/LOCODE',
  'operator.reference_data.col.name': '名稱',
  'operator.reference_data.col.country': '國家',
  'operator.reference_data.col.type': '類型',
  'operator.reference_data.empty': '沒有符合的地點。',
  'operator.reference_data.load_more': '載入更多',
}
